/**
 * Deployed Cloud Function names used by mobile/web clients and server-to-server HTTP callers.
 * Triggers, schedules, and webhooks are exported from `apps/functions/src/index.ts` but are not listed here.
 */
export enum FunctionList {
  // Callable — users (mobile / web, authenticated)
  Onboarding = "setOnboarding",
  Feedback = "sendFeedback",
  Tracking = "setTracking",
  GetUserRole = "getUserRole",
  GetSignedUrl = "getSignedUrl",
  RequestDownload = "requestDownload",
  RegisterUserToNewsletter = "registerUserToNewsletter",
  GetStripeManagementUrl = "getStripeManagementUrl",
  SyncMyAuthEmailToInternal = "syncMyAuthEmailToInternal",

  // HTTP — web SSR / sitemap (server-to-server bearer)
  GetPodcastEpisode = "getPodcastEpisode",
  GetPodcastEpisodes = "getPodcastEpisodes",
  GetBlogArticle = "getBlogArticle",
  GetBlogArticles = "getBlogArticles",
  GetAuthor = "getAuthor",
  GetAuthors = "getAuthors",
  GetAudioCourseEpisodeSample = "getAudioCourseEpisodeSample",
  GetMeditationDailyExample = "getMeditationDailyExample",
  GetAudioCourse = "getAudioCourse",
  GetAudioCourses = "getAudioCourses",
  GetMeditation = "getMeditation",
  GetMeditations = "getMeditations",
  GetContent = "getContent",

  // HTTP — web billing (server-to-server bearer)
  GetOffers = "getOffers",

  // HTTP — App Check token issuance
  GetAppCheckToken = "getAppCheckToken",

  // Callable — billing (Stripe / RevenueCat, App Check)
  GetActiveSubscription = "getActiveSubscription",
  CreateCheckout = "createCheckout",
  ValidatePromotionCode = "validatePromotionCode",

  // Callable — affiliate (Tolt, App Check)
  CreateClickTracking = "createClickTracking",

  // Callable — public web (App Check)
  GetSignedUrlWeb = "getSignedUrlWeb",
  GetAudioCourseEpisodeUrl = "getAudioCourseEpisodeUrl",
  GetMeditationDailyExampleUrl = "getMeditationDailyExampleUrl",
  SubmitContactForm = "submitContactForm",
  SubmitB2bEnquiryForm = "submitB2bEnquiryForm",
  SubmitB2bAppEnquiryForm = "submitB2bAppEnquiryForm",
  SubmitNewsletterForm = "submitNewsletterForm",
  SubmitResellerApplicationForm = "submitResellerApplicationForm",
  SubmitUserDeleteRequestForm = "submitUserDeleteRequestForm",
  SubmitContractCancellation = "submitContractCancellation",
  ConfirmContractCancellation = "confirmContractCancellation",
  SubmitWithdrawalRequest = "submitWithdrawalRequest",

  // Callable — promo codes
  CreatePromoCodes = "createPromoCodes",
  RedeemPromoCode = "redeemPromoCode",
  ListPromoCodes = "listPromoCodes",
  DeletePromoCode = "deletePromoCode",

  // Callable — gamification
  BootstrapGamificationFromActivityLog = "bootstrapGamificationFromActivityLog",
  FreshStartGamification = "freshStartGamification",
  RecordSessionComplete = "recordSessionComplete",

  // Callable — CMS admin tools
  AdminGetContentDuration = "adminGetContentDuration",
  AdminGetOfflineDownloadsCount = "adminGetOfflineDownloadsCount",
  AdminGetFeedbackResults = "adminGetFeedbackResults",
  AdminGetUserDocumentReport = "adminGetUserDocumentReport",
  AdminSetUserMailVerified = "adminSetUserMailVerified",
}
